import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appDisTouchmove]'
})
export class DisTouchmoveDirective {
    constructor() {}

    @HostListener('touchmove', ['$event']) onMove(event) {
        event.preventDefault();
        event.srcElement.click();
    }
}
